import React, {Component, ReactElement, ReactNode} from 'react'
import {MESSAGE_TYPE} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {Messages} from '../../../Messages'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import PPTextField from '../../../components/shared/forms/PPTextField'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import NatAreaCodeRepo from './repository/NatAreaCodeRepo'
import {NatPostAreaCode, NatPostAreaCodeParams} from './repository/NatPostAreaCode'
import {Location} from 'react-router-dom'

import {Table, TableBody, TableCell, TableRow} from '@mui/material'

interface Props {
    areaCodeRepo: NatAreaCodeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    inputItemAreaCode: string
    inputItemAreaName: string
    inputItemContactMailAddress: string

}

class NatAdminAreaCodeRegisterPage extends Component<Props & AdminPagePropsSet, States> {


    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.state = {
            inputItemAreaCode: '',
            inputItemAreaName: '',
            inputItemContactMailAddress: '',
        }

        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.onChangeInputItemAreaCode = this.onChangeInputItemAreaCode.bind(this)
        this.onChangeInputItemAreaName = this.onChangeInputItemAreaName.bind(this)
        this.onChangeInputItemContactMailAddress = this.onChangeInputItemContactMailAddress.bind(this)
        this.registerAreaCodeButton = this.registerAreaCodeButton.bind(this)
        this.JudgeDisplayRegisterButton = this.JudgeDisplayRegisterButton.bind(this)
    }

    async componentDidMount(): Promise<void> {
    }


    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        const request: NatPostAreaCodeParams = {
            areaCode: this.state.inputItemAreaCode,
            areaName: this.state.inputItemAreaName,
            contactMailAddress: this.state.inputItemContactMailAddress,
        }

        try {
            const response: Nullable<NatPostAreaCode> =
                await this.props.asyncCallFunction(
                    this.props.areaCodeRepo.postAreaCode.bind(
                        this.props.areaCodeRepo, request,
                    ),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0001.toString('地域コード')},
                )
            if (response && response.details) {
                this.props.navigate(`/admin/areaCode/${response.details.areaId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0007.toString('地域コード'),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    onChangeInputItemAreaCode(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({inputItemAreaCode: event.target.value})
    }

    onChangeInputItemAreaName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({inputItemAreaName: event.target.value})
    }

    onChangeInputItemContactMailAddress(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({inputItemContactMailAddress: event.target.value})
    }

    async registerAreaCodeButton(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0012.errorLevel,
                message: Messages.IOPCC0012.toString('地域コード'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )
    }

    JudgeDisplayRegisterButton(): boolean {
        return !!(this.state.inputItemAreaCode &&
            this.state.inputItemAreaName &&
            this.state.inputItemContactMailAddress)
    }

    renderFormTable(): ReactNode {
        return (
            <Table>
                <colgroup>
                    <col width={'10%'}/>
                    <col width={'20%'}/>
                    <col width={'45%'}/>
                    <col width={'25%'}/>
                </colgroup>
                <StyledTableCaption>地域コード情報</StyledTableCaption>
                <TableBody>
                    <TableRow>
                        <TableRowName required>地域コード</TableRowName>
                        <TableCell>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 2,
                                    },
                                }}
                                required
                                fullWidth
                                value={this.state.inputItemAreaCode}
                                onChange={this.onChangeInputItemAreaCode}
                                eventKeys={['areaCode']}
                                eventEmitter={this.props.eventEmitter}
                                autoFocus
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>地域名</TableRowName>
                        <TableCell colSpan={2}>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 50,
                                    },
                                }}
                                required
                                fullWidth
                                value={this.state.inputItemAreaName}
                                onChange={this.onChangeInputItemAreaName}
                                eventKeys={['areaName']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>連絡先メールアドレス</TableRowName>
                        <TableCell colSpan={2}>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 100,
                                    },
                                }}
                                required
                                fullWidth
                                value={this.state.inputItemContactMailAddress}
                                onChange={this.onChangeInputItemContactMailAddress}
                                eventKeys={['contactMailAddress']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        )
    }

    renderPageFooterArea(): ReactNode {

        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={!this.JudgeDisplayRegisterButton()}
                        onClick={this.registerAreaCodeButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        to={'/admin/areaCodeList'}
                    >
                        地域コード一覧へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderFormTable()}
                    </form>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )
    }
}

export default createAdminPage(NatAdminAreaCodeRegisterPage)
